// images
import mainEducation from "../assets/mainPage/mainEducation.webp";
import vybiraemspec1 from "../assets/otherPages/education/vybiraem_spec_1.webp";
import vybiraemspec2 from "../assets/otherPages/education/vybiraem_spec_2.webp";

import sobiraemcomputer1 from "../assets/otherPages/education/sobiraem_computer_samostoyatelno.webp";
import sobiraemcomp1 from "../assets/otherPages/education/sobiraem_comp_1.webp";

import kaknauchitsa1 from "../assets/otherPages/education/kak_nauchitsa_programmirovat.webp";
import kaknauchitsaprogr1 from "../assets/otherPages/education/kak_nauchitsa_1.webp";
import kaknauchitsaprogr2 from "../assets/otherPages/education/kak_nauchitsa_2.webp";
import kaknauchitsaprogr3 from "../assets/otherPages/education/kak_nauchitsa_3.webp";

import professiaProgr1 from "../assets/otherPages/education/professia_progr1.webp";
import professiaProgr2 from "../assets/otherPages/education/professia_progr2.webp";
import professiaProgr3 from "../assets/otherPages/education/professia_progr3.webp";

import kakoyYazyk1 from "../assets/otherPages/education/kakoy_yazyk1.webp";
import kakoyYazyk2 from "../assets/otherPages/education/kakoy_yazyk2.webp";
import kakoyYazyk3 from "../assets/otherPages/education/kakoy_yazyk3.webp";

export const educationArticles = [
  // ARTICLE 1 START
  {
    id: "Выбираем специализацию в программировании",
    img: mainEducation,
    pretitle: "Самообразование",
    title: "Выбираем специализацию в программировании",
    tagString: "самообразование программирование специализация",
    tags: [
      {
        tag: "самообразование",
        tagLink: "#",
      },
      {
        tag: "программирование",
        tagLink: "#",
      },
      {
        tag: "специализация",
        tagLink: "#",
      },
    ],
    linkToArticle: "/education/Выбираем специализацию в программировании",
    text: [
      {
        attribute: "paragraph",
        content:
          "Каждому, кто решил изучать программирование, следует в первую очередь определиться со специализацией. Учитывая свои сильные и слабые стороны, свои интересы, выяснить подойдет ли выбранная специальность. Статья дает краткие описания самых популярных направлений в программировании, среди которых каждый выберет подходящий путь.",
      },
      {
        attribute: "image",
        content: vybiraemspec1,
      },
      {
        attribute: "paragraph",
        content:
          "Сразу следует оговориться, что во время изучения программирования, вы без труда сможете обучиться нескольким специализациям. Дело в том, что в сущности, все языки программирования очень схожи — не в синтаксисе, а в алгоритмах поведения. Поэтому, веб-программист способен в короткие сроки освоить низкоуровневое программирование для написания компьютерных игр. Все что вам будет необходимо — это желание учиться и достаточное количество времени: какие-то специальности вы сможете освоить за несколько месяцев, а для других потребуются годы практики.",
      },
      {
        attribute: "image",
        content: vybiraemspec2,
      },
      {
        attribute: "paragraph",
        content: "Рассмотрим самые популярные направления:",
      },
      {
        attribute: "list",
        content: [
          { item: "веб-программирование" },
          { item: "разработка игр" },
          { item: "разработка приложений под iOS или Android" },
          { item: "разработка программного обеспечения(ПО)" },
        ],
      },
      {
        attribute: "paragraph",
        content:
          "В свою очередь веб-программирование включает в себя следующие специализации:",
      },
      {
        attribute: "list",
        content: [
          {
            item: "front-end разработчик создает интерфейс страниц сайта, необходимы знание HTML, CSS, ДжаваСкрипт",
          },
          {
            item: "back-end разработчик пишет код всего сайта, создает архитектуру базы данных, должен владеть одним из языков: РНР, Python, Ruby, Java; а также знать базы данных MySQL или аналогичные",
          },
        ],
      },
      {
        attribute: "paragraph",
        content:
          "Разработчик игр это очень емкое понятие, включает в себя три главных направления: создание ММО-игр, мобильных и десктопных игр. Требуются глубокие знания одного из языков С, С++, С#, Джава; DirectX или Open GL; а также любой игровой движок.",
      },
      {
        attribute: "paragraph",
        content:
          "Разработка мобильных приложений требует следующих знаний: для iOS — Objective C, Xcode и др.; для Android – Java, Android Studio и т.д.",
      },
      {
        attribute: "paragraph",
        content:
          "Разработка программного обеспечения включает в себя написание всевозможных редакторов, плееров, браузеров и много другого. Самыми лучшими для новичков являются языки РНР, С#, Делфи.",
      },
    ],
  },
  // ARTICLE 1 END

  // ARTICLE 2 START
  {
    id: "Собираем компьютер самостоятельно",
    img: sobiraemcomputer1,
    pretitle: "Самообразование",
    title: "Собираем компьютер самостоятельно",
    tagString: "компьютер сборка",
    tags: [
      {
        tag: "компьютер",
        tagLink: "#",
      },
      {
        tag: "сборка",
        tagLink: "#",
      },
    ],
    linkToArticle: "/education/Собираем компьютер самостоятельно",
    text: [
      {
        attribute: "paragraph",
        content:
          "Целью данной статьи является подготовка читателя к самостоятельному выбору всех комплектующих будущего компьютера. Все дело в том, что очень часто недобросовестные продавцы, понимая, что покупатель не разбирается в совместимости работы различных элементов, могут предложить тому некорректно собранный компьютер. Не забывайте, что правильно собранный компьютер прослужит вам гораздо дольше, сэкономит ваши нервы и деньги.",
      },
      {
        attribute: "image",
        content: sobiraemcomp1,
      },
      {
        attribute: "paragraph",
        content:
          "Начнем с главного вопроса: для каких целей вы планируете использовать компьютер? Вы, наверняка понимаете, что комплектующие мощного игрового компьютера разительно отличаются от офисного или рабочего компьютера, предназначенного для выполнения стандартных операций. Поэтому стоит учитывать, что действительно мощный, современный компьютер обойдется вам совсем недешево, в то время, как компьютер, который планируется использовать для работы с различными стандартными файлами можно собрать за минимальную сумму.",
      },
      {
        attribute: "paragraph",
        content:
          "Центральный процессор(CPU) — представляет собой «мозг» компьютера, производительность которого влияет на работу установленных программ, тут все просто, такие программы, как игры требуют высокую производительность, а программы для работы с текстовыми файлами — низкую. Более мощные(многоядерные) процессоры потребляют больше энергии и требуют соответствующей системы охлаждения.",
      },
      {
        attribute: "paragraph",
        content:
          "Видеокарта. Если вы собираете игровой компьютер, то начинать надо именно с выбора дискретной видеокарты, так как стандартная видеокарта не подходит для современных компьютерных игр. В зависимости от выбранной видеокарты, подбираются все прочие элементы. Для обычного офисного компьютера вполне подойдет материнская плата с встроенной видеокартой.",
      },
      {
        attribute: "paragraph",
        content:
          "Материнская плата(motherboard, MB). При подборе материнской платы, учитывайте совместима ли она с выбранным процессором, а также убедитесь что она имеет все необходимые разъемы и в нужном количестве. Так, например, для мощного компьютера необходимо наличие, как минимум четырех слотов для модулей памяти.",
      },
      {
        attribute: "paragraph",
        content:
          "Оперативная память(RAM или ОЗУ) — хранит информацию текущего процесса, если объема оперативной памяти будет недостаточно, то программа начнет тормозить, либо не будет исполняться. Тип модулей ОЗУ должен соответствовать слотам материнской памяти, кроме того скорость работы ОЗУ должна поддерживаться материнской платой. Для корректной работы ОЗУ все модули должны иметь одинаковые параметры(например, если вам нужна память 8ГБ — установите два модуля по 4ГБ или 4 по 2ГБ). Объем оперативной памяти напрямую влияет на выбор операционной системы: до 4ГБ — 32-битная, от 4ГБ — 64-битная. Это связано с тем, что 32-х разрядные системы не распознают больше 4 ГБ оперативной памяти.",
      },
      {
        attribute: "paragraph",
        content:
          "Жесткий диск(HDD или винчестер) — позволяет сохранять информацию: операционную систему, программы, игры, личную информацию. Помимо привычных магнитных жестких дисков, в продаже есть твердотельные накопители(SSD), которые можно устанавливать вместе с жесткими дисками, что в значительной степени увеличит производительность.",
      },
      {
        attribute: "paragraph",
        content:
          "Компьютерный блок питания(БП). Очень важный элемент всей системы, он питает электроэнергией все компоненты. Некачественный и недостаточно мощный блок питания может привести к поломке комплектующих. Поэтому рекомендуется купить надежный БП с запасом мощности.",
      },
      {
        attribute: "paragraph",
        content:
          "Корпус содержит в себе все элементы, от этого зависят его размеры, а также количество и тип охлаждающих вентиляторов. Мощные видеокарта и процессор требуют обязательной установки дополнительных элементов охлаждения на корпусе.",
      },
    ],
  },
  // ARTICLE 2 END

  // ARTICLE 3 START
  {
    id: "Как научиться программировать",
    img: kaknauchitsa1,
    pretitle: "Самообразование",
    title: "Как научиться программировать",
    tagString: "программирование самообразование",
    tags: [
      {
        tag: "программирование",
        tagLink: "#",
      },
      {
        tag: "самообразование",
        tagLink: "#",
      },
    ],
    linkToArticle: "/education/Как научиться программировать",
    text: [
      {
        attribute: "paragraph",
        content:
          "Технологии, в том числе компьютерные, развиваются все быстрее. Поэтому не удивительно, что все больше людей интересуются данным вопросом. В данной статье предложены ответы на самые важные вопросы для начинающих программистов.",
      },
      {
        attribute: "image",
        content: kaknauchitsaprogr1,
      },
      {
        attribute: "title",
        content: "Как и где учиться?",
      },
      {
        attribute: "paragraph",
        content:
          "Существует два способа: самостоятельное обучение или изучение программирования на специальных курсах, либо в учебных заведениях. Рассмотрим оба варианта.",
      },
      {
        attribute: "title",
        content: "Учебные заведения и специализированные курсы",
      },
      {
        attribute: "paragraph",
        content:
          "Пожалуй основным преимуществом данного способа изучения программирования является высокая эффективность, в сравнении с самостоятельным обучением. Ну и диплом, если вы выбрали ВУЗ, лишним никогда не будет. К этой же категории обучения можно отнести специализированные онлайн-курсы различных университетов. Преимуществ у подобного обучения множество: высокая скорость освоения материала, квалифицированные наставники, гарантированное,как правило, трудоустройство по окончании учебы. Ну а главным и существенным недостатком является то, что все это, как правило не бесплатно, хотя и существуют отличные бесплатные онлайн-ресурсы.",
      },
      {
        attribute: "image",
        content: kaknauchitsaprogr2,
      },
      {
        attribute: "title",
        content: "Самостоятельное обучение",
      },
      {
        attribute: "paragraph",
        content:
          "Для самостоятельного обучения следует обзавестись всем необходимым: установить на свой компьютер среду разработки выбранного языка, скачать из интернета или купить актуальную на сегодня книгу о данном языке. Практика показывает, что две-три хорошие книги для начинающих и дополнительное изучение материала в интернете, на различных сайтах и видео-тренингах, позволяют создать необходимый фундамент для дальнейшего развития в профессии. А дальнейшее развитие возможно лишь во время работы над большими, серьезными проектами.",
      },
      {
        attribute: "image",
        content: kaknauchitsaprogr3,
      },
      {
        attribute: "title",
        content: "Какой язык изучать?",
      },
      {
        attribute: "paragraph",
        content:
          "Для новичков этот вопрос, пожалуй, самый важный. Чтобы не ошибиться с первоначальным выбором языка программирования, необходимо определиться с теми задачами которые вы планируете решать — это могут быть, например, динамические веб-сайты или мобильные приложения для смартфонов. Для реализации разных задач применяются разные языки. Далее приведен перечень самых популярных языков:",
      },
      {
        attribute: "list",
        content: [
          {
            item: "Пайтон – по мнению большинства разработчиков, является приоритетным для изучения новичками, благодаря простоте синтаксиса. Подходит для решения большинства задач.",
          },
          {
            item: "Языки Си -  чаще всего используется для написания компьютерных программ и игр.",
          },
          {
            item: "ДжаваСкрипт и Джава — широко применяются для создания веб-плагинов и приложений.",
          },
          {
            item: "ПиЭйчПи — язык номер один для веб-программирования, который не требует много времени и усилий для изучения.",
          },
          {
            item: "Обджектив Си и Реакт Нейтив — используются для разработки мобильных приложений.",
          },
        ],
      },
      {
        attribute: "paragraph",
        content:
          "Конечно этот список можно продолжать еще долго, главное это точно определиться с направлением. Многие языки отлично дополняют друг друга. Чтобы не ошибиться с выбором, рекомендуется просмотреть объявления с интересующими вас вакансиями и выяснить какие знания интересуют потенциального работодателя, после чего приступать к обучению!",
      },
    ],
  },
  // ARTICLE 3 END

  // ARTICLE 4 START
  {
    id: "Профессия программист. Первые шаги",
    img: professiaProgr1,
    pretitle: "Самообразование",
    title: "Профессия программист. Первые шаги",
    tagString: "программирование самообразование профессия программист",
    tags: [
      {
        tag: "программирование",
        tagLink: "#",
      },
      {
        tag: "самообразование",
        tagLink: "#",
      },
      {
        tag: "профессия",
        tagLink: "#",
      },
      {
        tag: "программист",
        tagLink: "#",
      },
    ],
    linkToArticle: "/education/Профессия программист. Первые шаги",
    text: [
      {
        attribute: "paragraph",
        content:
          "Профессия программист — одна из самых востребованных и популярных в современном мире. Эта специальность отлично подойдет людям разных возрастных категорий. Она не требует каких-либо специфических, начальных знаний, например, таких как высшая математика. Научиться программировать на среднем уровне, по силам любому желающему. Далее о том, как сделать первые шаги в профессии программиста.",
      },
      {
        attribute: "image",
        content: professiaProgr2,
      },
      {
        attribute: "title",
        content: "Для начала рассмотрим основные способы обучения:",
      },
      {
        attribute: "list",
        content: [
          {
            item: "Учебное заведение(ВУЗ) больше подойдет для молодых людей, недавно закончивших школу. Многие, состоявшиеся программисты, скептически относятся к уровню знаний выпускников подобных учебных заведений, поэтому во время учебы в ВУЗе, дополнительно рекомендуется самостоятельное изучение программирования.",
          },
          {
            item: "Специализированные курсы по изучению программирования, в том числе с возможностью дальнейшего трудоустройства, есть практически в каждом городе. Такой способ обучения отлично подойдет тем, кто желает освоить профессию как можно скорее и приступить к работе уже через несколько месяцев.",
          },
          {
            item: "Самообразование, одновременно и самый сложный и самый правильный путь к становлению профессиональным программистом. Но не стоит пугаться — в интернете имеется масса ресурсов в свободном доступе, среди которых любой может подобрать удобную для себя модель обучения: интерактивные сайты, видеоуроки, специализированная литература, в том числе на русском языке и многое другое. Главное запастись терпением!",
          },
        ],
      },
      {
        attribute: "image",
        content: professiaProgr3,
      },
      {
        attribute: "title",
        content: "Выбор специальности и языка программирования.",
      },
      {
        attribute: "paragraph",
        content:
          "Чтобы понять какой язык программирования изучать, вы должны определить ту область в которой планируете делать карьеру. Для начинающих лучшим стартом будет разработка веб- или мобильных приложений. Разработка игр или низкоуровневое программирование требуют глубоких знаний таких языков, как Си, СиШарп и т.д., а изучение, особенно самостоятельное, подобных языков может стать очень сложной задачей и напрочь отбить желание программировать. Поэтому на начальном этапе рекомендуется изучение веб-технологий(ЭйчТиЭмЭл, СиЭсЭс, ДжаваСкрипт) и одного из серверных языков(Пайтон, ПиЭйчПи, Руби) с соответствующими ему фреймворками и базами данных.",
      },
      {
        attribute: "paragraph",
        content:
          "Самым популярным языком для новичков, по праву считается Пайтон. Все дело в простоте синтаксиса и большом ассортименте библиотек, что здорово упрощает написание самых разных программ. Язык Джава несколько сложнее, но при этом он более популярен и востребован. Изучив его можно переходить к низкоуровневым языкам. ПиЭйчПи, пожалуй самый простой язык, также очень востребованный, применяется исключительно для разработки веб-приложений. В качестве второго языка программирования отлично подойдет Руби.",
      },
      {
        attribute: "paragraph",
        content:
          "Еще одним важным компонентом в освоении профессии — является знание английского. Поэтому начинайте его изучать параллельно с программированием.",
      },
      {
        attribute: "paragraph",
        content:
          "И не забывайте о важнейшем умении всех программистов — способность находить ответы в интернете или по-другому «гуглить».",
      },
    ],
  },
  // ARTICLE 4 END

  // ARTICLE 5 START
  {
    id: "Какой язык программирования изучать первым",
    img: kakoyYazyk1,
    pretitle: "Самообразование",
    title: "Какой язык программирования изучать первым",
    tagString:
      "программирование самообразование программист язык программирования",
    tags: [
      {
        tag: "программирование",
        tagLink: "#",
      },
      {
        tag: "самообразование",
        tagLink: "#",
      },
      {
        tag: "программист",
        tagLink: "#",
      },
      {
        tag: "язык",
        tagLink: "#",
      },
      {
        tag: "программирования",
        tagLink: "#",
      },
    ],
    linkToArticle: "/education/Какой язык программирования изучать первым",
    text: [
      {
        attribute: "paragraph",
        content:
          "В статье предлагается краткое описание самых популярных языков программирования, область их применения и рекомендации по их изучению.",
      },
      {
        attribute: "paragraph",
        content:
          "Прежде чем начать изучение какого-либо языка, необходимо иметь четкое представление о той специализации которая будет вам интересна в дальнейшем. Это может быть разработка веб-приложений или компьютерных игр и многое другое. Если вы пока затрудняетесь с выбором, рекомендуется ознакомиться с описанием различных специализаций, а также просмотреть объявления с вакансиями для программистов, чтобы получить общее представление о той или иной специальности.",
      },
      {
        attribute: "paragraph",
        content:
          "Для начинающих программистов выбор первого языка очень важен. И причин здесь несколько: во-первых слишком сложный язык может навсегда отбить всякое желание изучать программирование; во-вторых выбранный язык должен нравиться; в-третьих язык должен быть востребован на рынке, иначе его изучение станет простой тратой времени.",
      },
      {
        attribute: "image",
        content: kakoyYazyk2,
      },
      {
        attribute: "paragraph",
        content:
          "Итак, начнем. Очень часто новичкам предлагаются такие языки, как «Бэйсик» или «Паскаль», они очень просты в изучении, но при этом практически нигде не используются, кроме, пожалуй учебных заведений. Вы, конечно, можете их освоить, чтобы получить начальное представление о принципах программирования, но лучше выбрать один из двух популярных языков, которые чаще других рекомендуются в качестве первого. Знакомьтесь — это «Пайтон» и «Джава».",
      },
      {
        attribute: "paragraph",
        content:
          "Язык программирования «Пайтон» является высокоуровневым языком разработки, что означает максимальную читаемость кода: очень часто отдельные блоки сценария читаются как обычный английский текст. Да, стоит заметить, что знание английского — неотъемлемый атрибут профессионального программиста, не верьте тем, кто утверждает обратное. О плюсах «Пайтона» можно рассказывать очень долго, а вот недостатков у него практически нет. Безусловный лидер а номинации «лучший первый язык программирования»!",
      },
      {
        attribute: "paragraph",
        content:
          "«Джава» - очень востребованный и популярный язык. Он несколько сложнее, чем «Пайтон», так как его синтаксис во многом схож с языками семейства «Си», которые в свою очередь являются низкоуровневыми, что делает их крайне нежелательными, для самостоятельного изучения с нуля.",
      },
      {
        attribute: "paragraph",
        content:
          "Оба представленных языка имеют самый широкий спектр применения, выбор за вами, стоит лишь заметить, что на просторах бывшего союза, «Джава» - более популярный.",
      },
      {
        attribute: "image",
        content: kakoyYazyk3,
      },
      {
        attribute: "paragraph",
        content:
          "Теперь о разработке веб-приложений и мобильных приложений, очень востребованных направлениях в программировании. Да для реализации данных задач могут подойти и «Джава» с «Пайтоном», но очень часто веб-разработчики изучают лишь «ПиЭйчПи», «ЭйчТиЭмЭл», «СиЭсЭс» и другие языки веб-программирования. Если вы хотите заниматься исключительно веб-разработкой, то помимо обозначенных, есть такие языки, как «обджектив Си», «Руби», «Перл» и другие. Все эти языки довольно просты и не требуют длительного изучения. Кроме того, для повышения профессиональных способностей, не лишним будет, помимо основного языка, например «Джава», изучить «ЭйчТиЭмЭл» и «СиЭсЭс».",
      },
      {
        attribute: "paragraph",
        content:
          "Общие рекомендации. Наберитесь терпения, если, к примеру, вы начали обучение по книге — будьте готовы, что в дальнейшем придется обратиться к другой книге или иному ресурсу, чтобы разобраться в каком-то моменте. К сожалению идеальных обучающих пособий, в любой дисциплине, никогда не существовало. Изучите первый язык полностью, прежде чем перейти к следующему. И, наконец, самое главное — больше практикуйтесь!",
      },
    ],
  },
  // ARTICLE 5 END
];
